const Cart = ({ isActive = true }) => {
    return (
        <svg
            width="27"
            height="26"
            viewBox="0 0 27 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="0.5"
                width="25.6"
                height="25.6"
                rx="4.8"
                fill={isActive ? '#EFE3FF' : 'transparent'}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.63379 7.23698C6.63379 6.86879 6.93227 6.57031 7.30046 6.57031H8.73333C9.50839 6.57031 10.163 7.14036 10.2729 7.90365H18.856C19.0417 7.90365 19.219 7.9811 19.3452 8.11735C19.4713 8.2536 19.535 8.43629 19.5207 8.62144L19.2025 12.7578C19.1046 14.0313 18.0426 15.0148 16.7653 15.0148H11.12L11.2025 15.7077C11.2158 15.8195 11.3106 15.9036 11.4231 15.9036H17.0782C17.4464 15.9036 17.7449 16.2021 17.7449 16.5703C17.7449 16.9385 17.4464 17.237 17.0782 17.237H11.4231C10.6352 17.237 9.97164 16.6478 9.87849 15.8653L8.954 8.0996C8.94069 7.98782 8.8459 7.90365 8.73333 7.90365H7.30046C6.93227 7.90365 6.63379 7.60517 6.63379 7.23698ZM10.9612 13.6814H16.7653C17.3459 13.6814 17.8286 13.2344 17.8731 12.6555L18.1361 9.23698H10.4321L10.9612 13.6814Z"
                fill={isActive ? '#9000FF' : '#616161'}
            />
            <path
                d="M13.3005 19.0148C13.3005 19.5057 12.9025 19.9036 12.4116 19.9036C11.9206 19.9036 11.5227 19.5057 11.5227 19.0148C11.5227 18.5238 11.9206 18.1259 12.4116 18.1259C12.9025 18.1259 13.3005 18.5238 13.3005 19.0148Z"
                fill={isActive ? '#9000FF' : '#616161'}
            />
            <path
                d="M17.7449 19.0148C17.7449 19.5057 17.3469 19.9036 16.856 19.9036C16.3651 19.9036 15.9671 19.5057 15.9671 19.0148C15.9671 18.5238 16.3651 18.1259 16.856 18.1259C17.3469 18.1259 17.7449 18.5238 17.7449 19.0148Z"
                fill={isActive ? '#9000FF' : '#616161'}
            />
        </svg>
    )
}

export default Cart
